import Api from "./api";
import { ajaxJWT } from "@/utils/request";

export function Article_add(parameter) {
  return ajaxJWT({
    url: Api.article_add,
    method: "post",
    data: parameter
  });
}

export function Article_list(parameter) {
  return ajaxJWT({
    url: Api.article_list,
    method: "post",
    data: parameter
  });
}
export function Article_detail(parameter) {
  return ajaxJWT({
    url: Api.article_detail,
    method: "post",
    data: parameter
  });
}
export function Article_update(parameter) {
  return ajaxJWT({
    url: Api.article_update,
    method: "post",
    data: parameter
  });
}
export function Article_delete(parameter) {
  return ajaxJWT({
    url: Api.article_delete,
    method: "post",
    data: parameter
  });
}
